const uploadPrefix = process.env.UPLOAD_PREFIX
const graphqlApiUrl = process.env.GRAPHQL_API_URL

const config = {
  uploadPrefix,
  graphqlApiUrl
}

export default config
